







import {Component, Vue} from 'vue-property-decorator';
import GlobalHeader from "@/components/GlobalHeader.vue";
import UsersBody from "@/components/users/UsersBody.vue";

@Component({
    components: {GlobalHeader, UsersBody}
})
export default class Users extends Vue {}
